import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import { datadogRum } from '@datadog/browser-rum';

datadogRum.init({
    applicationId: environment.dataDog.applicationId,
    clientToken: environment.dataDog.clientToken,
    site: 'us3.datadoghq.com',
    service: 'arriendos',
    env: environment.dataDog.env,
    version: '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: environment.dataDog.sessionReplaySampleRate,
    defaultPrivacyLevel: 'mask-user-input',
});

if (environment.production) {
  enableProdMode();
}

(function (w: any, d: Document, s: string, l: string, i: string) {
  w[l] = w[l] || [];
  w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
  const f = d.getElementsByTagName(s)[0] as HTMLElement;
  const j = d.createElement(s) as HTMLScriptElement;
  const dl = l !== 'dataLayer' ? '&l=' + l : '';
  j.async = true;
  j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
  f.parentNode!.insertBefore(j, f);
})(window, document, 'script', 'dataLayer', environment.gtmId);

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
